const itemPickersUrlBase = '/_ghui/item-pickers'

export function buildItemPickersUrl(endpoint: 'milestones' | 'issue_types') {
  return `${itemPickersUrlBase}/${endpoint}`
}

export function buildItemPickerSearchUrl(endpoint: 'milestones' | 'issue_types', params = {}) {
  const paramsString = new URLSearchParams(params).toString()
  return `${buildItemPickersUrl(endpoint)}${paramsString && `?${paramsString}`}`
}

export function buildItemPickersBulkActionsUrl() {
  return `${itemPickersUrlBase}/bulk_actions`
}
